module.exports = __webpack_public_path__ + "img/sdg8.c9871639.svg";